import { render, staticRenderFns } from "./ShareShortcut.vue?vue&type=template&id=313dceee&scoped=true&lang=html&"
import script from "./ShareShortcut.vue?vue&type=script&lang=js&"
export * from "./ShareShortcut.vue?vue&type=script&lang=js&"
import style0 from "./ShareShortcut.vue?vue&type=style&index=0&id=313dceee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313dceee",
  null
  
)

export default component.exports